package com.havn.app.core.billing

import com.havn.app.features.agency.domain.HavnSubscriptionTier

enum class HavnPlanTier {
    Free,
    SoloAgent,
    ProAgent
}

data class HavnPlanLimits(
    val visibleProperties: Int,
    val maxProperties: Int,
    val maxOpeningsPerProperty: Int
)

object HavnPlans {
    fun limitsFor(tier: HavnSubscriptionTier): HavnPlanLimits = when (tier) {
        HavnSubscriptionTier.Free -> HavnPlanLimits(
            visibleProperties = 1,
            maxProperties = 1,
            maxOpeningsPerProperty = 1
        )
        HavnSubscriptionTier.SoloAgent -> HavnPlanLimits(
            visibleProperties = 100,
            maxProperties = 100,
            maxOpeningsPerProperty = Int.MAX_VALUE
        )
        HavnSubscriptionTier.ProAgent -> HavnPlanLimits(
            visibleProperties = Int.MAX_VALUE,
            maxProperties = Int.MAX_VALUE,
            maxOpeningsPerProperty = Int.MAX_VALUE
        )
    }

    val freeLimits: HavnPlanLimits = limitsFor(HavnSubscriptionTier.Free)
}
